import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  FormLabel,
  FormControl,
  FormHelperText,
} from '@chakra-ui/react';

export const Base = (props) => {
  const {
    id,
    size,
    error,
    children,
    labelText,
    noOfLines,
    labelIcon,
    labelProps,
    'data-testid': dataTestId,
    ...contentProps
  } = props;
  const testID = dataTestId
    ? {
      label: `${dataTestId}.label`,
      textHelper: `${dataTestId}.textHelper`,
    }
    : null;

  return (
    <FormControl
      id={id}
      data-testid={dataTestId}
      {...contentProps}
    >
      {labelText
        && (
          <FormLabel
            mr="0"
            color="gray.700"
            fontSize={size}
            noOfLines={noOfLines}
            data-testid={testID?.label}
            {...labelProps}
          >
            {labelIcon && (
              <Box as="span" mr="0.5rem">
                {labelIcon}
              </Box>
            )}
            {labelText}
          </FormLabel>
        )}
      {children}
      {error && (
        <FormHelperText
          fontSize="sm"
          color="red.500"
          data-testid={testID?.textHelper}
        >
          {error.message}
        </FormHelperText>
      )}
    </FormControl>
  );
};

Base.defaultProps = {
  id: '',
  error: null,
  noOfLines: 1,
  labelText: '',
  labelProps: {},
  labelIcon: null,
  'data-testid': '',
};

Base.propTypes = {
  id: PropTypes.string,
  error: PropTypes.shape({ message: PropTypes.string }),
  noOfLines: PropTypes.number,
  labelText: PropTypes.node,
  labelIcon: PropTypes.element,
  'data-testid': PropTypes.string,
  labelProps: PropTypes.shape({}),
  children: PropTypes.element.isRequired,
};
